import React from 'react'
import { connectBreadcrumb } from 'react-instantsearch-dom'
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Icon from '@bit/atd.web.icons'
import Grid from '@bit/atd.web.grid'
import colors from '@bit/atd.web.colors'

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      fontSize: '14px',
      color: colors.ctaSecondary,
      textDecoration: 'none',
    },
    arrow: {
      transform: 'rotateY(180deg)',
      marginRight: '5px',
    },
  }),
)

const Breadcrumb = ({ items, refine, createURL }: any): any => {
  const history = useHistory()
  const classes = useStyles()
  const location = useLocation()

  const getIBreadcrumbIem = () => {
    if (items.length > 1) {
      const item = items[items.length - 2]
      return { ...item, label: `Back to ${item.label}` }
    }
  }

  const renderLink = (text: string) => (
    <Grid container alignItems="center">
      <Icon
        glyph="arrow-right"
        size={16}
        color={colors.ctaPrimary}
        className={classes.arrow}
      />
      <div>{text}</div>
    </Grid>
  )

  const item = getIBreadcrumbIem()
  const redirectUrl = `/search${location.search}`

  return item ? (
    <a
      href={`${createURL(item.value)}${location.search}`}
      className={classes.link}
      onClick={(event) => {
        event.preventDefault()
        if (item.value) {
          refine(item.value)
        } else {
          history.push(redirectUrl)
        }
      }}
    >
      {renderLink(item.label)}
    </a>
  ) : (
    <a
      href={createURL(redirectUrl)}
      className={classes.link}
      onClick={(event) => {
        event.preventDefault()
        history.push(redirectUrl)
      }}
    >
      {renderLink('All Categories')}
    </a>
  )
}

export default connectBreadcrumb(Breadcrumb)
